// redirects to make the old links work (at some point we can remove these)
export default [
  {
    path: '/RPC*',
    beforeEnter(to) {
      window.location.replace('https://rpc.resonancehealth.org' + to.fullPath);
    },
  },
  {
    path: '/universal-premedication-and-therapeutic-drug-monitoring-for-peg-asparaginase-pat-brown/',
    redirect: '/media/38',
  },
  {
    path: '/developing-a-national-guideline-to-manage-asparaginase-reactions-siobhan-cross/',
    redirect: '/media/37',
  },
  {
    path: '/laboratory-measurement-of-asparaginase-activity-carel-pretorius',
    redirect: '/media/39',
  },
  // educational content shown in the netwroks landing page
  {
    path: '/education',
    redirect: '/networks',
  },

  /** TODO wrap this under vanity link manager at some point */
  {
    path: '/2021AMLCMErequest',
    component: () => import(/* webpackchunkname: "vanity" */ '@/views/Vanity.vue'),
  },
  {
    path: '/alrcanmeet',
    redirect: '/al-rcan-meet',
  },
];
